import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d6u3af1qcrg2vc5aq0lg';

export default function SMMLeadForm() {
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('sending');
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as URLSearchParams);
    try {
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="smm-form" className="py-12 sm:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">

        {/* CTA-заголовок */}
        <div className="text-center mb-8 sm:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-money-dollar-circle-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Сделайте соцсети активом
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight max-w-3xl mx-auto text-justify sm:text-center">
            Ваши социальные сети могут стать либо статьёй расходов, либо мощным активом.
          </h2>
          <p className="text-base sm:text-xl text-[#C5A880] font-semibold font-['Montserrat'] mb-6 text-justify sm:text-center">
            Давайте сделаем их прибыльными.
          </p>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mb-7"></div>
        </div>

        {/* Form card */}
        <div id="smm-form-block" className="bg-gradient-to-br from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">

            {/* LEFT — Photo + Info (desktop only) */}
            <div className="hidden lg:flex lg:w-[42%] flex-col items-center justify-center p-14 bg-white/5">
              <div className="w-64 rounded-2xl overflow-hidden mb-5 flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/bc89a6f73ddaed1a26846899a6dde312.png"
                  alt="Ирина Шарова-Ялынпала — Маркетолог-стратег"
                  className="w-full h-auto object-contain"
                />
              </div>
              <div className="text-center">
                <p className="text-white font-bold text-lg font-['Playfair_Display'] leading-snug mb-1">
                  Ирина Шарова-Ялынпала
                </p>
                <p className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] mb-1">
                  Маркетолог-стратег
                </p>
                <p className="text-[#C5A880]/80 text-xs font-['Montserrat'] mb-2">
                  Специалист по системному маркетингу и нейро-инструментам
                </p>
                <p className="text-white/70 text-sm font-['Montserrat'] leading-relaxed mb-5">
                  Помогаю бизнесу расти, объединяя психологию потребителя и технологии будущего.
                </p>
                <div className="border-t border-white/15 pt-4">
                  <p className="text-white/60 text-sm font-['Montserrat'] leading-relaxed italic">
                    «Соцсети — это не витрина. Это воронка продаж, которая работает 24/7.»
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT — Form */}
            <div className="w-full lg:w-[58%] p-6 sm:p-10 lg:p-14">

              {/* Mobile expert card (hidden on lg+) */}
              <div className="lg:hidden flex flex-col bg-white/10 rounded-2xl overflow-hidden mb-6 border border-white/15">
                {/* Photo — full width, proportions preserved */}
                <div className="w-full">
                  <img
                    src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/bc89a6f73ddaed1a26846899a6dde312.png"
                    alt="Ирина Шарова-Ялынпала — Маркетолог-стратег"
                    className="w-full h-auto object-contain"
                  />
                </div>
                {/* Text below photo */}
                <div className="p-5">
                  <p className="text-white font-bold text-lg font-['Playfair_Display'] leading-snug mb-1">
                    Ирина Шарова-Ялынпала
                  </p>
                  <p className="text-[#C5A880] text-sm font-semibold font-['Montserrat'] mb-2">
                    Маркетолог-стратег
                  </p>
                  <p className="text-[#C5A880]/80 text-sm font-['Montserrat'] mb-3 leading-relaxed text-justify">
                    Специалист по системному маркетингу и нейро-инструментам
                  </p>
                  <p className="text-white/70 text-sm font-['Montserrat'] leading-relaxed text-justify">
                    Помогаю бизнесу расти, объединяя психологию потребителя и технологии будущего.
                  </p>
                  <div className="border-t border-white/15 mt-4 pt-4">
                    <p className="text-white/60 text-sm font-['Montserrat'] leading-relaxed italic text-justify">
                      «Соцсети — это не витрина. Это воронка продаж, которая работает 24/7.»
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-6 sm:mb-8">
                <div className="inline-flex items-center gap-2 bg-[#C5A880]/30 border border-[#C5A880]/50 px-4 py-2 rounded-full text-xs font-semibold text-[#FFE0A8] mb-4 font-['Montserrat']">
                  <i className="ri-send-plane-line"></i>
                  Заявка на SMM-стратегию
                </div>
                <h3 className="text-xl sm:text-3xl font-['Playfair_Display'] font-bold text-white mb-3 leading-tight">
                  Получить стратегию продвижения
                </h3>
                <p className="text-xs sm:text-sm text-white/60 leading-relaxed font-['Montserrat']">
                  Расскажите о вашем бизнесе — мы проанализируем конкурентов и покажем, как соцсети
                  станут вашим главным каналом привлечения клиентов.
                </p>
              </div>

              {status === 'success' ? (
                <div className="text-center py-10">
                  <div className="w-16 h-16 bg-[#C5A880]/30 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-[#C5A880] text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-bold text-white font-['Playfair_Display'] mb-2">
                    Заявка отправлена!
                  </h3>
                  <p className="text-white/60 text-sm font-['Montserrat']">
                    Мы свяжемся с вами в течение 24 часов.
                  </p>
                </div>
              ) : (
                <form data-readdy-form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Ваше имя *
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="Иван Иванов"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="ivan@company.ru"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Телефон
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        placeholder="+7 (000) 000-00-00"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors"
                      />
                    </div>
                    <div>
                      <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                        Тип клиента
                      </label>
                      <select
                        name="client_type"
                        className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors appearance-none cursor-pointer"
                      >
                        <option value="" className="text-gray-800">Выберите тип</option>
                        <option value="expert" className="text-gray-800">Эксперт / Консультант</option>
                        <option value="business" className="text-gray-800">Предприниматель / Бизнес</option>
                        <option value="startup" className="text-gray-800">Стартап</option>
                        <option value="other" className="text-gray-800">Другое</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="text-white/70 text-xs font-['Montserrat'] font-semibold uppercase tracking-wider mb-2 block">
                      О вашем бизнесе и задаче
                    </label>
                    <textarea
                      name="message"
                      rows={3}
                      maxLength={500}
                      placeholder="Расскажите о нише, продукте, текущем присутствии в соцсетях..."
                      className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/30 text-sm font-['Montserrat'] focus:outline-none focus:border-[#C5A880] transition-colors resize-none"
                    />
                  </div>

                  {status === 'error' && (
                    <p className="text-red-400 text-xs font-['Montserrat'] text-center">
                      Ошибка при отправке. Попробуйте ещё раз.
                    </p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'sending'}
                    className="w-full bg-[#C5A880] hover:bg-[#B39770] disabled:opacity-60 text-white py-4 px-3 sm:px-6 rounded-xl font-semibold text-xs sm:text-base font-['Montserrat'] transition-all duration-300 hover:scale-[1.02] cursor-pointer leading-snug"
                  >
                    {status === 'sending' ? 'Отправка...' : 'Заказать разработку SMM-стратегии'}
                    {status !== 'sending' && <i className="ri-arrow-right-line ml-2"></i>}
                  </button>

                  <p className="text-white/40 text-xs text-center font-['Montserrat']">
                    Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности
                  </p>
                </form>
              )}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
